import { NgModule } from '@angular/core';
import { LibFetchingTransactionsEuroIconComponent } from './lib-fetching-transactions-euro-icon.component';

@NgModule({
  declarations: [LibFetchingTransactionsEuroIconComponent],
  imports: [],
  exports: [LibFetchingTransactionsEuroIconComponent],
})
export class LibFetchingTransactionsEuroIconModule {}
